var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00336 7.88882C7.36594 7.88882 6.81545 7.36094 6.81545 6.68643V1.20238C6.81545 0.557203 7.33697 0 8.00336 0C8.66974 0 9.19126 0.527876 9.19126 1.20238V6.68643C9.19126 7.36094 8.64077 7.88882 8.00336 7.88882ZM4.43963 5.48405C4.72937 5.24944 4.90321 4.89752 4.90321 4.5456C4.90321 3.5485 3.74427 2.9913 2.96199 3.63648C0.962829 5.27876 -0.225079 7.85949 0.0356817 10.6748C0.412335 14.5753 3.57043 17.6839 7.42389 17.9771C12.0886 18.329 16 14.5753 16 9.91234C16 7.36094 14.8411 5.1028 13.0157 3.60715C12.2624 2.9913 11.1035 3.5485 11.1035 4.5456C11.1035 4.92685 11.2773 5.24944 11.5671 5.48405C12.8419 6.5398 13.6532 8.12343 13.6532 9.91234C13.6532 13.2556 10.7558 15.9536 7.36594 15.5724C4.75834 15.2791 2.67226 13.1383 2.4115 10.4989C2.20868 8.47535 3.04891 6.65711 4.43963 5.48405Z",
    fill: "#D3626D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.b8c97623b5a8fdaa62f1d1cae9cf4bcc.svg";
export { ForwardRef as ReactComponent };